export * from "./DialogMessageConfig";
export * from "./DialogMessageConstants";
export * from "./DialogMessage";
import * as CMP from "./components";
export { CMP as DialogMessageComponents };
//# sourceMappingURL=index.js.map